import api from './';

export const salvarEmpresaCertificado = async (formData) => {
    const { data } = await api.post('/empresa-certificado', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

    return data;
};

export const listarEmpresaCertificados = async (empresaId) => {
    const { data } = await api.get('/empresa-certificado', {
        params: {
            empresaId,
        },
    });

    return data;
};

export const testarEmpresaCertificado = async ({ empresaId, uuid }) => {
    const { data } = await api.post('/empresa-certificado/testar', {
        empresaId,
        uuid,
    });

    return data;
};
